"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIQUIDITY_VERSION_TO_SERUM_VERSION = exports.LIQUIDITY_VERSION_TO_PROGRAMID = exports.LIQUIDITY_PROGRAMID_TO_VERSION = exports.LIQUIDITY_PROGRAM_ID_V4 = exports._LIQUIDITY_PROGRAM_ID_V4 = void 0;
const web3_js_1 = require("@solana/web3.js");
/* ================= program public keys ================= */
exports._LIQUIDITY_PROGRAM_ID_V4 = "675kPX9MHTjS2zt1qfr1NYHuzeLXfQM9H24wFSUt1Mp8";
exports.LIQUIDITY_PROGRAM_ID_V4 = new web3_js_1.PublicKey(exports._LIQUIDITY_PROGRAM_ID_V4);
// liquidity program id string => liquidity version
exports.LIQUIDITY_PROGRAMID_TO_VERSION = {
    [exports._LIQUIDITY_PROGRAM_ID_V4]: 4,
};
// liquidity version => liquidity program id
exports.LIQUIDITY_VERSION_TO_PROGRAMID = {
    4: exports.LIQUIDITY_PROGRAM_ID_V4,
};
// liquidity version => serum version
exports.LIQUIDITY_VERSION_TO_SERUM_VERSION = {
    4: 3,
};
//# sourceMappingURL=id.js.map